<template>
    <div>
        <div>Average emails sent per contact (last 30 days)</div>
        <div v-if="loading">
            <div :style="{width: '60%', 'padding-bottom': '1rem'}">
                <ds-placeholder :rows="rows1_thick" />
            </div>
            <div :style="{width: '100%'}">
                <ds-placeholder :rows="rows3" />
            </div>
            <div :style="{width: '85%', 'padding-top': '1rem', 'padding-bottom': '2rem'}">
                <ds-placeholder :rows="rows1" />
            </div>
        </div>
        <div v-else>
            <div class="average-email-sent">
                {{ getAverageEmailSentPerContact }}
            </div>
            <p>
                On average you’re sending <strong>{{ getAverageEmailSentPerContact }}</strong>
                emails to each contact every 30 days. The ideal email frequency is
                <strong>4-8</strong>
                emails per contact every 30 days, or 1-2 emails a week,
                anything above this could lead to an increase in complaints.
            </p>
        </div>
        <div class="row">
            <div class="column">
                Unique contacts emailed
            </div>
            <div class="column">
                Total emails sent
            </div>
        </div>
        <div class="row">
            <div class="column">
                <div v-if="loading">
                    <div :style="{width: '70%'}">
                        <ds-placeholder :rows="rows1_thick" />
                    </div>
                </div>
                <div v-else class="email-metrics-footer">
                    {{ getUniqueContactsEmailed }}
                </div>
            </div>
            <div class="column">
                <div v-if="loading">
                    <div :style="{width: '70%'}">
                        <ds-placeholder :rows="rows1_thick" />
                    </div>
                </div>
                <div v-else class="email-metrics-footer">
                    {{ getTotalEmailsSent }}
                </div>
            </div>
        </div>
        <div class="align-right">
            <a href="https://help.keap.com/help/spam-complaints" target="_blank">
                Learn More <ds-icon class="learn-more-icon" name="external-link" />
            </a>
        </div>
    </div>
</template>

<script>

import { numberFormatCompact } from '@/utils/numbers.util';

const DEFAULT_TOTAL_EMAILS_SENT = 0;

export default {

    props: {
        averageEmailSentPerContact: {
            type: Number,
            default: 0,
        },
        uniqueContactsEmailed: {
            type: Number,
            default: 0,
        },
        totalEmailsSent: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            loading: true,
            rows3: [
                { height: '1rem', boxes: [] },
                { height: '1rem', boxes: [] },
            ],
            rows1: [
                { height: '1rem', boxes: [] },
            ],
            rows1_thick: [
                { height: '3rem', boxes: [] },
            ],
        };
    },
    watch: {
        averageEmailSentPerContact() {
            this.loading = false;
        },
    },
    computed: {
        getTotalEmailsSent() {
            return numberFormatCompact(this.totalEmailsSent);
        },
        getUniqueContactsEmailed() {
            return numberFormatCompact(this.uniqueContactsEmailed);
        },
        getAverageEmailSentPerContact() {
            if (this.averageEmailSentPerContact != null) {
                return numberFormatCompact(this.averageEmailSentPerContact.toFixed(2));
            }

            return DEFAULT_TOTAL_EMAILS_SENT;
        },
    },
};

</script>

<style lang="scss" rel="stylesheet/scss" scoped>
.learn-more-icon {
    --icon-size: #{px-to-rem(12px)};
}

.column {
    float: left;
    width: 50%;
}

/* Clear floats after the columns */
.row:after {
    content: "";
    display: table;
    clear: both;
}

.email-metrics-footer {
    font-size: $font-size-jumbo;
}

.average-email-sent {
    font-size: $font-size-mega;
}

.align-right {
    text-align: right;
}

</style>
